import React, { useMemo } from "react"
import { Flex, Typography } from "antd"
import { EnvironmentOutlined, CompassOutlined } from "@ant-design/icons"
import { useSelector } from "react-redux"
import { modelSelector } from "store/selectors"
import { getLocalStorageBrowserLocation } from "helpers/location"
import TripLocation from "pagesV2/pro/Experiences/ListingLocation/utils/Location"
import { useWizardContext } from "../../../WizardContext"
import styles from "./PreviewLocation.module.css"

const { Title, Text } = Typography

export const PreviewLocation = () => {
  const { form } = useWizardContext()
  const trip = useSelector(modelSelector("trip"))
  const address = form.getFieldValue("address")
  const additionalDirections = form.getFieldValue("additional_directions")

  const browserLocation = useMemo(() => getLocalStorageBrowserLocation(), [])
  const tripLatLng =
    trip?.latitude && trip?.longitude ? { lat: trip.latitude, lng: trip.longitude } : null
  const centerLatLng = tripLatLng || browserLocation

  if (!address) return null

  return (
    <div className={styles.container}>
      <Title level={3} className={styles.title}>{"Meeting Location"}</Title>

      <Flex align="center" gap="small" className={styles.addressRow}>
        <span className={styles.metaIconWrap}>
          <EnvironmentOutlined className={styles.metaIcon} />
        </span>
        <Text className={styles.address}>{address}</Text>
      </Flex>

      <div className={styles.mapWrap}>
        <TripLocation height={300} centerLatLng={centerLatLng} meetingLatLng={address} />
      </div>

      {additionalDirections && (
        <div className={styles.directionsWrap}>
          <Flex align="center" gap="small" className={styles.directionsHeader}>
            <CompassOutlined className={styles.directionsIcon} />
            <Text strong className={styles.directionsTitle}>{"Meeting Instructions"}</Text>
          </Flex>
          <Text className={styles.directionsText}>{additionalDirections}</Text>
        </div>
      )}
    </div>
  )
}
